import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['fixed', 'template', 'fieldAppendContainer']

  connect() {
    let renderedFields = this.fixedTarget.getAttribute('data-rendered-fixed')
  }

  appendRow() {
    const existingFixedRowCount = document.querySelectorAll('.existing-fixed-row').length
    const templateFixedRowCount = document.querySelectorAll('.fixed-row-template').length
    const fixedRowCount = templateFixedRowCount + existingFixedRowCount
    const content = this.templateTarget.innerHTML.replace(/FIXED_ROW_COUNT/g, fixedRowCount)
    this.fixedTarget.insertAdjacentHTML('beforebegin', content)
  }

  removeField(event) {
    let fieldHolder = event.target.closest('.field-holder')

    if (fieldHolder) {
      // Save reference to form before removing field
      const form = fieldHolder.closest('form')

      // Remove field first
      fieldHolder.remove()

      // Then submit form
      if (form && typeof form.requestSubmit === "function") {
        form.requestSubmit()
      }
    }
  }
}
